export default __webpack_public_path__ + "static/media/truck.001e09b3.svg";